import {Layout, Spin} from "antd";
import NpiDisplayMenu from "./components/display/menu";
import NpiBreadcrumb from "./components/breadcrumb";
import {Navigate, Route, Routes} from "react-router-dom";
import NpiContainerWaveConfig from "./containers/wave-config";
import NpiContainerNpiConfig from "./containers/npi-config";
import NpiContainerWaveList from "./containers/wave-list";
import NpiContainerNpiList from "./containers/npi-list";
import NpiContainerKpiDashboard from "./containers/kpi-dashboard";
import NpiContainerDashboardSync from "./containers/dev-dashboard/dashboard-synchro";
import NpiContainerDashboardSyncWaveDetails from "./components/dashboard-synchro/wave-details";
import RegionProtectedRoute from "./components/route/RegionProtectedRoute";
import NpiContainerDashboardShipment from "./containers/dashboard-shipment";
import NpiContainerAdminUserList from "./containers/admin/user-list";
import React from "react";
import {StoresContext} from "./contexts/stores";
import {WaveStore} from "./stores/wave";
import {NpiStore} from "./stores/npi";
import NpiContainerWaveTableReport from "./containers/wave-table-report";
import NpiContainerGallery from "./containers/gallery";
import NpiBatteryChartContainer from "./containers/battery-chart";
import NpiContainerAdminContactList from "./containers/admin/contact-list";
import NpiContainerAdminCountryList from "./containers/admin/country-list";
import {WavePosStore} from "./stores/wavepos";
import NpiContainerAdminTableauConnect from "./containers/admin/tableau-connect";
import {KpiDashboardStore} from "./stores/kpi-dashboard";
import NpiContainerAdminUserPreferences from "./containers/admin/user-preferences";
import NpiContainerAdminTags from "./containers/admin/tags";
import NpiContainerAdminPosList from "./containers/admin/pos-list";
import NpiContainerWwDashboard from "./containers/ww-dashboard";
import NpiContainerWwDashboardList from "./containers/ww-dashboard-list";
import i18n from "i18next";
import NpiContainerDevDashboard from "./containers/dev-dashboard/dev-dashboard";
import NpiContainerDashboardTranslation from "./containers/dev-dashboard/dashboard-translation";

const wavePosStore = new WavePosStore();
const waveStore = new WaveStore();
const npiStore = new NpiStore();
const kpiDashboardStore = new KpiDashboardStore();

const NpiInternalApp = () => {

    // Wait initialization of i18n lib
    if(!i18n.isInitialized){
        return <div style={{textAlign: 'center', padding: '30px 50px'}}>
            <Spin tip={<>Loading NPI interface...</>}/>
        </div>
    }

    return (
        <StoresContext.Provider value={{wavePosStore, waveStore, npiStore, kpiDashboardStore}}>
                <Layout id="npi-app" className="layout">
                    <Layout.Header style={{padding: 0}}>
                        <NpiDisplayMenu/>
                    </Layout.Header>
                    <Layout.Content>
                        <NpiBreadcrumb/>
                        <Routes>
                            <Route path="/npi/:npiId/wave/:waveId/config/:step?" element={<NpiContainerWaveConfig/>}/>
                            <Route path="/wave/:waveId/config/:step?" element={<NpiContainerWaveConfig/>}/>

                            <Route path="/npi/:npiId/wave/:waveId/report/:filters?" element={<NpiContainerWaveTableReport/>}/>
                            <Route path="/wave/:waveId/report/:filters?" element={<NpiContainerWaveTableReport/>}/>

                            <Route path="/npi/:npiId/config/:step?" element={<NpiContainerNpiConfig/>}/>
                            <Route path="/npi/:npiId" element={<NpiContainerWaveList/>}/>
                            <Route path="/npi" element={<NpiContainerNpiList/>}/>
                            <Route path="/kpi-dashboard/wave/:waveId/:mode?" element={<NpiContainerKpiDashboard/>}/>
                            <Route path="/kpi-dashboard/npi/:npiId/:mode?" element={<NpiContainerKpiDashboard/>}/>
                            <Route path="/ww-dashboard/:dashboardId" element={<NpiContainerWwDashboard/>}/>
                            <Route path="/ww-dashboard" element={<NpiContainerWwDashboardList/>}/>
                            <Route path="/battery-chart/:npiId" element={<NpiBatteryChartContainer/>}/>

                            <Route path="/dev-dashboard/sync/wave/:waveId" element={<NpiContainerDashboardSyncWaveDetails/>}/>
                            <Route path="/dev-dashboard/sync" element={<NpiContainerDashboardSync/>}/>
                            <Route path="/dev-dashboard/translation" element={<NpiContainerDashboardTranslation/>}/>
                            <Route path="/dev-dashboard" element={<NpiContainerDevDashboard/>}/>

                            <Route path="/gallery/npi/:npiId" element={<NpiContainerGallery/>}/>
                            <Route path="/gallery/wave/:waveId/:posId?" element={<NpiContainerGallery/>}/>
                            <Route path="/gallery" element={<NpiContainerGallery/>}/>

                            <Route element={<RegionProtectedRoute regionPermissions="has_shipment_access"/>}>
                                <Route path="/shipments" element={<NpiContainerDashboardShipment />} />
                            </Route>
                            <Route path="/admin/preferences" element={<NpiContainerAdminUserPreferences/>}/>
                            <Route path="/admin/users" element={<NpiContainerAdminUserList/>}/>
                            <Route path="/admin/countries" element={<NpiContainerAdminCountryList/>}/>
                            <Route path="/admin/contacts" element={<NpiContainerAdminContactList/>}/>
                            <Route path="/admin/tableau" element={<NpiContainerAdminTableauConnect/>}/>

                            <Route element={<RegionProtectedRoute regionPermissions="has_tags_access"/>}>
                                <Route path="/admin/tags" element={<NpiContainerAdminTags />} />
                            </Route>
                            <Route path="/admin/pos" element={<NpiContainerAdminPosList/>}/>

                            <Route path="/" element={<Navigate to="/npi" replace/>}/>
                            <Route path="*" element={<Navigate to="/npi" replace/>}/>
                        </Routes>
                    </Layout.Content>
                </Layout>
        </StoresContext.Provider>

    );
}

export default NpiInternalApp;
